import { logger as pinoLogger } from '@mc/pino-logger'

type Level = 'log' | 'info' | 'warn' | 'error'

const _logger = (level: Level, message: string, logProps: unknown) => {
  if (level === 'log' || level === 'info') {
    pinoLogger.info(logProps, message)
  } else if (level === 'warn') {
    pinoLogger.warn(logProps, message)
  } else if (level === 'error') {
    pinoLogger.error(logProps, message)
  } else {
    pinoLogger.info(logProps, message)
  }
}

/**
 * @deprecated Use @mc/pino-logger directly instead
 */
export const logger = {
  log: (message: string, props?: unknown) => _logger('log', message, props),
  error: (message: string, props?: unknown) => _logger('error', message, props),
}

export const nullLogger = {
  log: () => {},
  error: () => {},
}
